import React from 'react';

export default ({ color = '#fff', className, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    className={className}
    style={style}
  >
    <g fill="none" fillRule="evenodd">
      <g fill={color} fillRule="nonzero">
        <g>
          <g>
            <path
              d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm5.178-18.687v.001c.414-.273.969-.838 1.1-1.393-.41.279-.897.423-1.393.413.565-.272.979-.686 1.12-1.393-.545.292-.959.565-1.665.707-1.535-1.828-5.18-.415-4.474 2.373-2.534-.132-4.07-1.395-5.322-2.788-.696 1.12-.14 2.938.84 3.494-.567 0-.85-.131-1.122-.273 0 1.394.848 2.232 1.97 2.656H11.11c.415.96 1.121 1.666 2.373 1.666-.828.848-2.514 1.262-3.766 1.12 1.12.839 2.373 1.394 4.2 1.253 4.322-.142 7.26-3.363 7.26-7.836h.001z"
              transform="translate(-1781.000000, -3543.000000) translate(1677.000000, 3543.000000) translate(104.000000, 0.000000)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
